import { useEffect, useState } from 'react'

export default function useCurrentPathname(history: any) {
  const [currentPathname, setCurrentPathanme] = useState(history.location.pathname)

  useEffect(() => {
    history.listen(({ pathname }: { pathname: string }) => setCurrentPathanme(pathname))
  }, [])

  return currentPathname
}
